<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('举报人姓名')" prop="reporterName">
                <a-input v-model="queryParam.reporterName" :maxLength="32" :placeholder="$t('请输入')+$t('举报人姓名')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('举报类型')" prop="reportType">
                <a-select v-model="queryParam.reportType" :placeholder="$t('请选择')" allow-clear>
                  <a-select-option v-for="item in reportTypeList" :key="item.type" :value="item.type">{{ $t(item.name) }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('内容类型')" prop="contentType">
                <a-select v-model="queryParam.contentType" :placeholder="$t('请选择')" allow-clear>
                  <a-select-option v-for="item in reportTypeDataList" :key="item.id" :value="item.title">{{ $t(item.title) }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('举报开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('举报结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['discovery:discoveryreport:remove']">
          <a-icon type="delete" />
          {{ $t('删除') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <div slot="reportType" slot-scope="text, record">
          {{ reportTypeMap[record.reportType] }}
        </div>
        <div slot="status" slot-scope="text, record">
          <span v-if="record.status === 0">{{$t('待处理')}}</span>
          <span v-else-if="record.status === 1">{{$t('已处理')}}</span>
          <span v-else-if="record.status === 2">{{$t('无需处理')}}</span>
        </div>
        <div slot="reportImage" slot-scope="text, record">
          <div style="width:40px;height:40px;">
            <img v-if="record.reportImage" :src="record.reportImage" style="width:40px;height:40px;" @click="handleRecordPreview(record.reportImage)" alt="none" />
          </div>
        </div>
        <span slot="reportTime" slot-scope="text, record">
          {{ parseTime(record.reportTime) }}
        </span>
        <span slot="handleTime" slot-scope="text, record">
          {{ parseTime(record.handleTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['discovery:discoveryreport:remove']">
            {{ $t('删除') }}
          </a>
          <a v-if="record.status === 0" @click="handleHandle(record)" v-hasPermi="['discovery:discoveryreport:edit']">
            {{ $t('立即处理') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <handle-modal ref="handleModalRef" @ok="getList" />
  </page-header-wrapper>
</template>

<script>
import { pageDiscoveryReport, delDiscoveryReport } from '@/api/discovery/discoveryReport'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { parseTime } from '@/utils/ruoyi'
import { listDiscoveryReportType } from '@/api/discovery/discoveryReportType'
import HandleModal from '@/views/discovery/discoveryReport/modules/HandleModal.vue'

export default {
  name: 'DiscoveryReport',
  components: {
    HandleModal,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        reportType: undefined,
        contentId: undefined,
        contentType: undefined,
        reportedContent: undefined,
        reporterId: undefined,
        reporterName: undefined,
        status: undefined,
        reportTime: undefined,
        handleResult: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '120px',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('举报类型'),
          dataIndex: 'reportType',
          scopedSlots: { customRender: 'reportType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('被举报内容'),
          dataIndex: 'reportedContent',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('内容类型'),
          dataIndex: 'contentType',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('举报人姓名'),
          dataIndex: 'reporterName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('举报图片'),
          dataIndex: 'reportImage',
          scopedSlots: { customRender: 'reportImage' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('描述'),
          dataIndex: 'description',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('举报状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('举报时间'),
          dataIndex: 'reportTime',
          scopedSlots: { customRender: 'reportTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '150px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ],
      reportTypeList: [{ type: 'user', name: this.$t('举报用户') }, { type: 'article', name: this.$t('举报文章') }, { type: 'comment', name: this.$t('举报评论') }],
      reportTypeMap: {
        'user': this.$t('举报用户'),
        'article': this.$t('举报文章'),
        'comment': this.$t('举报评论')
      },
      reportTypeDataList: []
    }
  },
  filters: {},
  created() {
    this.getList()
    this.getReportTypeDataList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    parseTime,
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getReportTypeDataList() {
      listDiscoveryReportType({}).then(res => {
        this.reportTypeDataList = res.data
      })
    },
    /** 查询举报列列表 */
    getList() {
      this.loading = true
      pageDiscoveryReport(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        reportType: undefined,
        contentId: undefined,
        contentType: undefined,
        reportedContent: undefined,
        reporterId: undefined,
        reporterName: undefined,
        status: undefined,
        reportTime: undefined,
        handleResult: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delDiscoveryReport(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('discovery/discovery/report/export',
            that.queryParam
            , `举报列_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleHandle(row) {
      this.$refs.handleModalRef.openModal(row.id, row.contentId, row.reportType)
    }
  }
}
</script>
